import { EXCLUDED_URL_REGEXES, EXCLUDED_URL_SUBSTRINGS } from '../../../config/excluded-urls';

/**
 * Checks if the current URL matches any excluded pattern.
 */
export const isUrlExcluded = (): { excluded: boolean; matchedPattern?: string } => {
	if (EXCLUDED_URL_SUBSTRINGS.length === 0 && EXCLUDED_URL_REGEXES.length === 0) {
		return { excluded: false };
	}

	const currentUrl = window.location.href;

	for (const substring of EXCLUDED_URL_SUBSTRINGS) {
		if (currentUrl.includes(substring)) {
			return { excluded: true, matchedPattern: substring };
		}
	}

	for (const regex of EXCLUDED_URL_REGEXES) {
		if (regex.test(currentUrl)) {
			return { excluded: true, matchedPattern: regex.source };
		}
	}

	return { excluded: false };
};
